import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Alert, AlertTitle, Snackbar, styled } from '@mui/material';
import React from 'react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  autoHideDuration?: number;
}

const StyledAlert = styled(Alert)(({ theme }) => ({
  alignItems: 'center',
  width: '100%',
  maxWidth: '600px',
  boxShadow: theme.shadows[3],
  zIndex: theme.zIndex.snackbar + 1,
  backgroundColor: '#4caf50', // Default MUI success color
  color: '#fff', // White text
  '& .MuiAlert-icon': {
    color: '#fff', // White icon
  },
  '& .MuiAlertTitle-root': {
    color: '#fff', // White title
  },
}));

export const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  autoHideDuration = 5000,
}) => (
  <Snackbar
    open={isOpen}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <StyledAlert
      icon={<CheckCircleOutlineIcon fontSize="large" />}
      severity="success"
      onClose={onClose}
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </StyledAlert>
  </Snackbar>
);
